import ModalVideo from '../partials/modal-video'

export default class Essence {
  constructor() {
    this.dataVideo = document.querySelectorAll('[data-video]')

    this.initVideos()
  }


  initVideos() {
    this.dataVideo.forEach((el) => {
      el.addEventListener('click', () => {
        const urlVideo = el.dataset.video
        new ModalVideo(urlVideo)
      })
    })
  }
}
